<script setup>
import { Link } from '@inertiajs/vue3'
import Pagination from '@/Shared/Pagination.vue'
import Portrait from '@/Shared/Portrait.vue'
import Icon from '@/Shared/Icon.vue'
import SearchInput from '@/Shared/SearchInput.vue'

defineProps({
  levels: {
    type: Object,
    default: () => {}
  }
})

const breadcrumbs = [{ label: 'Clases' }, { label: 'Niveles' }]
</script>

<template>
  <Portrait
    title="Niveles"
    subtitle="Gestiona los niveles de las clases del club"
    :breadcrumbs="breadcrumbs"
  >
    <div class="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <SearchInput
        v-model="search"
        class="w-full sm:w-64"
        placeholder="Buscar niveles..."
        url="/lessons/levels"
        :debounce-time="250"
        :only="['levels']"
      />

      <div class="flex space-x-3 items-stretch">
        <Link
          class="btn-indigo flex items-center justify-center w-full"
          href="/lessons/levels/create"
        >
          <Icon name="Plus" class="h-5 w-5 mr-2" />
          <span>Nuevo nivel</span>
        </Link>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr class="text-left font-medium text-gray-700 bg-gray-50 border-b border-gray-200">
              <th class="py-3 px-6">Nombre</th>
              <th class="py-3 px-6">Descripción</th>
              <th class="py-3 px-6">Color</th>
              <th class="py-3 px-6"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="level in levels.data"
              :key="level.id"
              class="hover:bg-gray-50 focus-within:bg-gray-50 border-b border-gray-100 last:border-b-0"
            >
              <td class="py-3 px-6">
                <Link
                  class="flex items-center text-gray-800 hover:text-indigo-600"
                  :href="`/lessons/levels/${level.id}/edit`"
                >
                  {{ level.name }}
                </Link>
              </td>
              <td class="py-3 px-6">
                <Link
                  class="flex items-center text-gray-800 hover:text-indigo-600"
                  :href="`/lessons/levels/${level.id}/edit`"
                  tabindex="-1"
                >
                  {{ level.description }}
                </Link>
              </td>
              <td class="py-3 px-6">
                <Link
                  class="flex items-center"
                  :href="`/lessons/levels/${level.id}/edit`"
                  tabindex="-1"
                >
                  <div :style="`background-color: ${level.color};`" class="w-12 h-6 rounded" />
                </Link>
              </td>
              <td class="py-3 px-6 text-right">
                <Link
                  class="inline-flex items-center text-gray-400 hover:text-indigo-600"
                  :href="`/lessons/levels/${level.id}/edit`"
                  tabindex="-1"
                >
                  <Icon name="CheveronRight" class="w-5 h-5" />
                </Link>
              </td>
            </tr>
            <tr v-if="levels.data.length === 0">
              <td class="px-6 py-4 text-center text-gray-500" colspan="5">
                No hay niveles todavía.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Pagination class="mt-6" :links="levels.links" />
  </Portrait>
</template>
